import { DefaultScheduleOn, MessageReliabilityProcessConfig } from './process.config';
import { MessageReliabilityProcessName } from './process.names';

const validateProcessConfig = (config: MessageReliabilityProcessConfig): void => {

  if (config.rateBucketKey && !config.rateLimit) {
    throw new Error(`MessageReliabilityProcessConfig '${config.process}': rateBucketKey requires rateLimit config`);
  }
  if (config.concurrencyBucketKey && !config.concurrencyLimit) {
    throw new Error(`MessageReliabilityProcessConfig '${config.process}': concurrencyBucketKey requires concurrencyLimit config`);
  }
  if (config.rateLimit && !config.rateBucketKey) {
    throw new Error(`MessageReliabilityProcessConfig '${config.process}': rateLimit requires rateBucketKey`);
  }
  if (config.concurrencyLimit && !config.concurrencyBucketKey) {
    throw new Error(`MessageReliabilityProcessConfig '${config.process}': concurrencyLimit requires concurrencyBucketKey`);
  }
  if (config.retryPolicy?.kind === 'limited' && (!Number.isFinite(config.retryPolicy.maxAttempts) || config.retryPolicy.maxAttempts < 1)) {
    throw new Error(`MessageReliabilityProcessConfig '${config.process}': retryPolicy.maxAttempts must be at least 1`);
  }
};

export class MessageReliabilityProcessRegistry {
  private static registry = new Map<string, MessageReliabilityProcessConfig>();

  static register(processConfig: MessageReliabilityProcessConfig): void {

    validateProcessConfig(processConfig);

    this.registry.set(processConfig.process, {
      ...processConfig,
      scheduleOn: processConfig.scheduleOn ?? DefaultScheduleOn,
    });
  }

  static registerMany(processConfigs: MessageReliabilityProcessConfig[]): void {

    processConfigs.forEach(config => this.register(config));
  }

  static get(process: MessageReliabilityProcessName): MessageReliabilityProcessConfig | undefined {

    return this.registry.get(process);
  }

  static getAll(): MessageReliabilityProcessConfig[] {

    return Array.from(this.registry.values());
  }
}

export const registerProcessConfig = (...processConfigs: MessageReliabilityProcessConfig[]): void => {

  MessageReliabilityProcessRegistry.registerMany(processConfigs);
};
